import React from 'react';
import {
  Linking,
  Platform,
  StyleSheet,
  TouchableOpacity,
  View,
} from 'react-native';
import Styles from '../../Styles';
import Localized from 'src/constants/AppStrings';
import AVText from 'src/components/elements/AVText';
import LocationPermissionErrorIcon from 'src/components/img/svg/LocationPermissionErrorIcon';
import LocationMarkerErrorIcon from 'src/components/img/svg/LocationMarkerErrorIcon';
import Settings from 'src/Settings';
import {getDescriber} from 'src/components/elements/home/descriptor/DescriptorType';

//Location Error Types
//LocationPermission - When Location Permission is disbaled/denied
//NoNearbyLocations - When Location Permission enabled but there are no nearby location
//LocationBalanceMismatch - When Location Balance and Consumer Balance Mismatched
export enum LocationErrorStatusType {
  LocationPermission = 'LocationPermission',
  NoNearbyLocations = 'NoNearbyLocations',
  LocationBalanceMismatch = 'LocationBalanceMismatch',
}

type LocationErrorStatusProps = {
  locationErrorStatusType: LocationErrorStatusType;
};
const {getCampusLocationStyles} = getDescriber();

const LocationErrorStatus = (props: LocationErrorStatusProps) => {
  const descriptionText = (): string => {
    switch (props.locationErrorStatusType) {
      case LocationErrorStatusType.LocationPermission:
        return Localized.Labels
          .turn_location_services_on_to_access_nearby_locations;
      case LocationErrorStatusType.NoNearbyLocations:
        return Localized.Labels.there_are_no_locations_near_you;
      case LocationErrorStatusType.LocationBalanceMismatch:
        return Localized.Labels
          .your_account_balance_is_not_valid_at_some_locations;
    }
  };

  return (
    <View
      style={[
        styles.container,
        props.locationErrorStatusType ===
        LocationErrorStatusType.LocationPermission
          ? {height: Styles.Heights.h7 * 2.6}
          : {height: Styles.Heights.h7 * 2},
      ]}
    >
      <View style={styles.imageView}>
        {props.locationErrorStatusType ===
        LocationErrorStatusType.LocationPermission ? (
          <LocationPermissionErrorIcon />
        ) : (
          <LocationMarkerErrorIcon />
        )}
      </View>
      <AVText
        style={[
          getCampusLocationStyles()['descriptionText'],
          styles.descriptionText,
        ]}
        accessible={false}
        accessibilityElementsHidden={true}
        accessibilityLabel={descriptionText()}
        accessibilityRole="text"
        aria-label={`${descriptionText()}, text`}
        maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm1}
      >
        {descriptionText()}
      </AVText>
      {props.locationErrorStatusType ===
        LocationErrorStatusType.LocationPermission &&
        Settings.is365Pay() && (
          <View style={{paddingTop: 12}}>
            <TouchableOpacity
              style={[styles.locationSettings]}
              onPress={() => {
                Linking.openSettings();
              }}
              accessibilityRole="button"
              accessibilityLabel={Localized.Buttons.go_to_location}
              role="button"
              aria-label={Localized.Buttons.go_to_location}
              testID={Localized.Buttons.go_to_location}
            >
              <AVText
                style={styles.locationSettingsbtnStyle}
                maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm6}
                testID={Localized.Buttons.go_to_location}
                adjustsFontSizeToFit={true}
              >
                {Localized.Buttons.go_to_location}
              </AVText>
            </TouchableOpacity>
          </View>
        )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    width: '100%',
    //height: Styles.Heights.h7 * 2,
    justifyContent: 'center',
    alignItems: 'center',
  },
  descriptionText: {
    color: Settings.is365Pay() ? '#111' : Styles.black,
    fontSize: Styles.Fonts.f7,
    fontWeight: '400',
    textAlign: 'center',
    marginTop: Styles.Spacing.m2,
  },
  imageView: {
    justifyContent: 'center',
    alignItems: 'center',
    width: Styles.Heights.h5,
    height: Styles.Heights.h5,
    marginBottom: Styles.Spacing.m2,
  },
  locationSettings: {
    borderTopColor: '#066DFF',
    borderBottomColor: '#066DFF',
    borderLeftColor: '#066DFF',
    borderRightColor: '#066DFF',
    borderRadius: 32,
    borderWidth: Platform.OS === 'android' ? 1.2 : 1,
    paddingVertical: 10,
    paddingHorizontal: 20,
    overflow: 'hidden',
    backgroundColor: '#066DFF',
  },
  locationSettingsbtnStyle: {
    fontWeight: Platform.OS === 'android' ? 'bold' : '700',
    fontFamily: Styles.FontFamily.aeonikRegular,
    fontSize: Styles.Fonts.f0 + 4,
    color: Styles.white,
  },
});

export default LocationErrorStatus;
